/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    form?: unknown;
  };
}

import Component from "@glimmer/component";

const prostateMutations = ["brca2", "brca1", "atm", "cdk12", "chek2", "hoxb13"];

export default class MedicalHistoryFormPancreaticCancerPathologyComponent extends Component<Signature> {
  get prostateMutations(): string[] {
    return prostateMutations;
  }
}
